import React, { useEffect } from "react";
import Menu from "../components/Menu";
import Register from "../components/Register";
import { setTitle } from "../helpers/title";

export default function RegisterPage() {
  useEffect(() => {
    setTitle("Daftar Akun");
  }, []);

  return (
    <div>
      <div className="container"></div>
      <div className="content">
        <Register />
      </div>
      <Menu />
    </div>
  );
}
